<template>
  <header class="header-bar">
    <div class="title">
      <h2 class="header__h2">{{title? title : 'Статистика'}}</h2>
      <p class="subtitle">Показатель — заявки</p>
    </div>
    <div class="controls" v-if="showButtons">

      <select class="header__select" v-model="localRange" @change="emitRange">
        <div v-for="(value, key) in statistic">
          <option :value="key">{{getRangeTitle(key)}}</option>
        </div>
      </select>
      <button class="header__button" @click="$emit('refresh')">Обновить</button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderBar',
  props: ['statistic', 'ranges', 'title', 'showButtons'],
  data() {
    return { 
      localRange: String('current_year') 
    }
  },
  methods: {
    getRangeTitle (key) {
      return this.ranges.find(item => item.key == key)?.title
    },
    emitRange() {
      this.$emit('change-range', this.localRange);
    }
  },
  watch: {
  }
};
</script>

<style scoped>
.title {
  text-align: left;
}
.header-bar {
  display:flex;
  justify-content:
  space-between;
  align-items:center;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.controls {
  display: flex;
  gap: 0.5rem
}
.header__button{
  padding: 0.5rem 1rem;
  border-radius: 0.5rem; 
  border: 0.1rem solid #e6eef8;
  background: transparent; 
  color: var(--color-0)
}

.header__select {
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: 0.1rem solid #e6eef8;
  background: transparent;
  color: var(--color-0);

  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;

  background-image: url("data:image/svg+xml;utf8,<svg fill='gray' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 1rem;
}


.header__select:focus {
  border: 0.1rem solid #e6eef8 !important;
}
.subtitle {
  color: #64748b;
  margin: 0; 
  text-align: left;
}

.header__h2 {
  text-align: left;
}
</style>









